import { render, staticRenderFns } from "./pay-statis.vue?vue&type=template&id=152338c6&"
import script from "./pay-statis.vue?vue&type=script&lang=js&"
export * from "./pay-statis.vue?vue&type=script&lang=js&"
import style0 from "./pay-statis.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports